export default {
  EN_ATTENTE: 0,
  VALIDER: 1,
  REFUSER: 2,
  DEMANDE_ACHAT: 3,
  COLLECTE_PRIX: 4,
};
